import { Box } from '@mui/material';
import { FsButton } from '../../../../../../shared/components/button';
import { DialogWrapper } from '../../../../../../shared/components/common/dialogWrapper';
import { useTranslation } from 'react-i18next';

export const WithdrawWarningDialog = ({ state, onClose = (e) => {} }) => {
	const { t } = useTranslation();
	return (
		<DialogWrapper
			hideCloseBtn={true}
			maxWidth="xs"
			state={state}
			title={t('withdrawalRequest')}
			onClose={() => {
				onClose(false);
			}}
			content={
				<Box className="flex flex-col justify-center">
					<p className="text-center !text-[14px]">
						<span>{t('withdrawalRequestText1')}</span>
						&nbsp;<strong>$30</strong>.&nbsp;
						<span>{t('withdrawalRequestText2')}</span>
					</p>
				</Box>
			}
			actions={
				<Box className="flex items-center space-x-2">
					<FsButton
						variant="outline"
						onClick={() => {
							onClose(false);
						}}>{t('cancel')}</FsButton>
					<FsButton
						onClick={() => {
							onClose(true);
						}}>{t('withdraw')}</FsButton>
				</Box>
			}></DialogWrapper>
	);
};
